import { render } from "./loader.html?vue&type=template&id=84409eb4&scoped=true&external"
import script from "./loader.js?vue&type=script&lang=js&external"
export * from "./loader.js?vue&type=script&lang=js&external"

import "./LoaderView.vue?vue&type=style&index=0&id=84409eb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84409eb4"]])

export default __exports__